import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import { Box, Tabs, Tab } from '@mui/material';
import { connect } from 'react-redux';
import ReportDialogBox from '../../ReportDialogBox';
import TabsContent from '../../TabsContent';

const useStyles = makeStyles((_theme) => ({
  root: {
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",

  },
  main: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: 'row',
    padding: "0 7px",
    // paddingRight: "24px",
    whiteSpace: "nowrap",
  },
  tabContainer: {
    flex: 1,
    borderBottom: "2px solid #C6C7C8",
  },
  activeTab: {
    borderBottom: "5px solid #0067A1 !important",
    color: "#0067A1 !important",
    fontSize: "14px !important",
    fontWeight: "600 !important",
    textTransform: 'none !important',
  },
  inactiveTab: {
    color: "#333 !important",
    fontSize: "14px !important",
    textTransform: 'none !important',
  },
  tabPanel: {
    padding: "0px !important",
  },
  indicator: {
    display: 'none',
  },
}));

const TabPanel = ({ children, value, index, ...other }) => (
  <div
    role="tabpanel"
    hidden={value !== index}
    id={`simple-tabpanel-${index}`}
    aria-labelledby={`simple-tab-${index}`}
    {...other}
  >
    {value === index && <Box pt={3} pl={1} pr={1} pb={3}>{children}</Box>}
  </div>
);

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

const a11yProps = (index) => ({
  id: `simple-tab-${index}`,
  'aria-controls': `simple-tabpanel-${index}`,
});

const Distribution_Planning_TabComponent = ({ tabIndex, tabChange, KPIData, mapData, tabList, MapLoading, Module, graphViewTabList, KPILoading, setTabIndexAndName }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  const handleChange = (_event, newValue) => {
    tabChange(newValue);
    setTabIndexAndName(tabList[newValue].name);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div className={classes.root}>
      <div className={classes.main}>
        <Tabs
          value={tabIndex}
          onChange={handleChange}
          className={classes.tabContainer}
          aria-label="simple tabs example"
          classes={{ indicator: classes.indicator }}
        >
          {tabList.map((item, index) => (
            <Tab
              key={index}
              className={tabIndex === index ? classes.activeTab : classes.inactiveTab}
              label={item.label}
              {...a11yProps(index)}
            />
          ))}
        </Tabs>
        <ReportDialogBox handleClose={handleClose} open={open} />
      </div>
      {tabList.map((_item, index) => (
        <TabPanel key={index} value={tabIndex} index={index} className={classes.tabPanel}>
          <TabsContent
            data={KPIData}
            KPILoading={KPILoading}
            mapData={mapData}
            tabIndex={tabIndex}
            tabList={tabList}
            MapLoading={MapLoading}
            Module={Module}
            graphViewTabList={graphViewTabList}
            type={'Distribution_Planning'}
          />
        </TabPanel>
      ))}
    </div>
  );
};

Distribution_Planning_TabComponent.propTypes = {
  tabIndex: PropTypes.number.isRequired,
  tabChange: PropTypes.func.isRequired,
  setTabIndexAndName: PropTypes.func.isRequired,
  KPIData: PropTypes.object,
  mapData: PropTypes.array,
  tabList: PropTypes.array.isRequired,
  MapLoading: PropTypes.bool,
  Module: PropTypes.string,
  graphViewTabList: PropTypes.array,
  KPILoading: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  tabIndex: state.tabs.index,
});

const mapDispatchToProps = (dispatch) => ({
  tabChange: (newValue) => dispatch({ type: 'TAB_INDEX', payload: newValue }),
  setTabIndexAndName: (newValue) => dispatch({ type: 'TAB_NAME', payload: newValue }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Distribution_Planning_TabComponent);
